import React, { Component } from 'react';
import lottie from 'lottie-web';
import PropTypes from 'prop-types';
import loaderAnimation from '../../static/animations/loader_opportunities.json';

class OpportunitiesLoader extends Component {
  static propTypes = {
    size: PropTypes.number,
    message: PropTypes.string,
    inverted: PropTypes.bool
  };

  componentDidMount() {
    lottie.loadAnimation({
      container: this.loaderContainer,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: loaderAnimation
    });
  }

  render() {
    const { size, message } = this.props;
    return (
      <div>
        <div style={{ width: size || 120, height: size || 120 }} ref={ref => (this.loaderContainer = ref)}></div>
        {message && <div className='loader-message'>{message}</div>}
      </div>
    );
  }
}

export default OpportunitiesLoader;
